const GLOBAL_TUNNEL_KEY = 'active_tunnel_global';

export const TunnelState = {
    getActiveTunnel: () => {
        const data = localStorage.getItem(GLOBAL_TUNNEL_KEY);
        return data ? JSON.parse(data) : null;
    },

    setActiveTunnel: (
        thingName,
        tunnelId,
        sourceToken,
        region,
        sessionId = null
    ) => {
        const existing = TunnelState.getActiveTunnel();

        if (existing && existing.thingName !== thingName) {
            return {
                success: false,
                message: `Cannot start tunnel. Another tunnel is active for device: ${existing.thingName}`,
                activeTunnel: existing
            };
        }

        const tunnelData = {
            thingName,
            tunnelId,
            sourceToken,
            region,
            sessionId,
            startedAt: new Date().toISOString()
        };

        localStorage.setItem(
            GLOBAL_TUNNEL_KEY,
            JSON.stringify(tunnelData)
        );

        localStorage.setItem(`session_${thingName}`, tunnelId);

        return { success: true, tunnelData };
    },

    clearActiveTunnel: (thingName) => {
        const existing = TunnelState.getActiveTunnel();

        if (existing && existing.thingName === thingName) {
            localStorage.removeItem(GLOBAL_TUNNEL_KEY);
            localStorage.removeItem(`session_${thingName}`);
            return true;
        }

        return false;
    },

    isActiveTunnelForDevice: (thingName) => {
        const tunnel = TunnelState.getActiveTunnel();
        return tunnel && tunnel.thingName === thingName;
    },

    hasAnyActiveTunnel: () => {
        return TunnelState.getActiveTunnel() !== null;
    }
};